import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";
import AppLayout from "./components/AppLayout";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import LoginPage from "./pages/LoginPage";
import TodayPage from "./pages/TodayPage";
import SessionsPage from "./pages/SessionsPage";
import SessionDetailPage from "./pages/SessionDetailPage";
import SessionActivePage from "./pages/SessionActivePage";
import PlanSessionPage from "./pages/PlanSessionPage";
import ExercisesPage from "./pages/ExercisesPage";
import SettingsPage from "./pages/SettingsPage";
import OnboardingPage from "./pages/OnboardingPage";
import AdminPage from "./pages/AdminPage";
import {
  CookiesPage,
  PrivacyPage,
  SubProcessorsPage,
  SupportPage,
  TermsPage,
} from "./pages/StaticPages";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />

          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/sub-processors" element={<SubProcessorsPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="/support" element={<SupportPage />} />

          <Route element={<AppLayout />}>
            <Route index element={<TodayPage />} />
            <Route path="/sessions" element={<SessionsPage />} />
            <Route path="/sessions/plan" element={<PlanSessionPage />} />
            <Route path="/sessions/:id" element={<SessionDetailPage />} />
            <Route path="/sessions/:id/active" element={<SessionActivePage />} />
            <Route path="/exercises" element={<ExercisesPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/onboarding" element={<OnboardingPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
